import React, { useRef, useEffect } from "react";
import homeVideo from "../videos/homepage.mp4";
import Content from "../components/content";
import CardSlider from "./ProductCardsSection";
import ProductCarousel from "../components/ProductCarousel";
import Product from "./Product";
import ClientReview from "./ClientReview";
import Section from "./Section";
import CustomCarousel from "./CustomCarousel";
import Collection from "../components/Collection";
import NewImage from "../Images/image45.png"

function Home() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Play when visible, pause when not
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="video-hero">
        <video
          ref={videoRef}
          className="hero-video"
          src={homeVideo}
          muted
          loop
          playsInline
          preload="metadata"
          onCanPlayThrough={() => videoRef.current?.play()}
        />

        <div className="hero-overlay">
          <h1 className="hero-title"></h1>
          {/* <button className="shop-btn1" data-aos="zoom-in">
            Shop Now
          </button> */}
        </div>
      </section>

      <div className="about-wrapper">
        <div className="about-card">
          <h1 data-aos="fade-up" id="discover">
            Welcome to Fashion Afrique
          </h1>
          <p>
            Discover the beauty of African fashion, culture, and lifestyle with African Fashion.
            We bring you a curated collection of premium clothing, accessories, and unique designs inspired by African heritage.
            Our mission is to deliver quality, style, and confidence to every shopper across the globe.
          </p>

          <p>
            From modern trends to traditional elegance, African Shopping is your one-stop destination for authentic and stylish products crafted with passion and excellence.
          </p>
        </div>
      </div>

      {/* new section added */}

       

      <section className="New-section">
  <div className="New-container">
    <div className="New-wrapper">

      {/* Text Column */}
      <div className="New-content">
        <h1 className="new-h1">Elevate Your Style</h1>

        <p>
          Discover premium fashion collections designed for
          modern men and women. Shop the latest trends and
          express your unique style.
        </p>

        <button className="new-btn1">
          Explore Collection
        </button>
      </div>

      {/* Image Column */}
      {/* <div className="Newimage-col">
        <img src={NewImage} alt="Fashion Model" />
      </div> */}

      <div className="Newimage-col">
        <div className="image-frame">
           <img src={NewImage} alt="Fashion Model" />
        </div>
      </div>
    </div>
  </div>
</section>
<Collection />
  {/* <CustomCarousel /> */}
      <Content />
      <ProductCarousel />
      <CardSlider />
      <Section />
      <Product />
      <ClientReview />
    </>
  );
}

export default Home;
